import {RealtimeMessageType} from 'notebook/realtime/Constants';
import {DocumentUpdateMessageHandler} from 'notebook/realtime/DocumentUpdateMessageHandler';
import {displayNotification} from 'notebook/realtime/DocumentUpdateNotifications';
import {fetchAndUpdateFileLockState} from 'notebook/realtime/DocumentUpdatesManager';

export const lockUpdateMessageHandler: DocumentUpdateMessageHandler<typeof RealtimeMessageType.LOCK_UPDATE> =
  {
    active: (fileId, {lock, userNotifications = []}) => {
      for (const notification of userNotifications) {
        displayNotification(notification);
      }
      fetchAndUpdateFileLockState(fileId, lock);
    },
  };
